
import React from 'react';
import NavBar from '@/components/NavBar';
import { Card, CardContent } from '@/components/ui/card';
import { Sun } from 'lucide-react';
import Footer from '@/components/Footer';

const AboutPage = () => {
  return (
    <div className="flex flex-col min-h-screen bg-warm-cream">
      <NavBar />
      
      <main className="flex-1">
        <div className="container px-3 sm:px-4 md:px-6 py-4 sm:py-6 space-y-4 sm:space-y-6">
          <div className="flex flex-col items-center text-center space-y-2 sm:space-y-3 mb-6 sm:mb-8">
            <div className="flex items-center space-x-2">
              <Sun className="h-6 w-6 sm:h-8 sm:w-8 text-peach-orange" />
              <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-sunset-dark">About FollowTheSun</h1>
            </div>
            <p className="text-sm sm:text-base text-sunset-medium max-w-[90%] sm:max-w-[600px] leading-relaxed">
              A community-driven guide to finding sun in Stockholm. Stockholm is just the beginning - next up: every sun-chasing city.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            <Card>
              <CardContent className="p-4 sm:p-6">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-sunset-dark">Our Mission</h2>
                <p className="text-sm sm:text-base text-sunset-medium leading-relaxed">
                  FollowTheSun was created to help locals and visitors maximize their time in the sun. In a city where sunny days are precious, we want to make sure you know exactly where to go to soak up some vitamin D while enjoying the best terraces Stockholm has to offer.
                </p>
              </CardContent>
            </Card>
            
            <Card>
              <CardContent className="p-4 sm:p-6">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-sunset-dark">How It Works</h2>
                <p className="text-sm sm:text-base text-sunset-medium leading-relaxed">
                  We combine real-time weather data with sun position tracking to identify which terraces have sun right now. Our AI-powered forecasting also predicts which terraces will have sun in the next hour, so you can plan ahead.
                </p>
              </CardContent>
            </Card>
            
            <Card className="md:col-span-2">
              <CardContent className="p-4 sm:p-6">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-sunset-dark">Community-Powered</h2>
                <p className="text-sm sm:text-base text-sunset-medium mb-3 sm:mb-4 leading-relaxed">
                  FollowTheSun is powered by our community. Know a great sunny terrace that's not on our list? Help us grow by submitting new terraces to our database.
                </p>
                <p className="text-sm sm:text-base text-sunset-medium leading-relaxed">
                  In the future, we plan to add user ratings, real-time crowding indicators, and special event listings for terraces across Stockholm.
                </p>
              </CardContent>
            </Card>
          </div>
          
          <div className="text-center mt-6 sm:mt-8 px-4">
            <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-sunset-dark">Contact Us</h2>
            <p className="text-sm sm:text-base text-sunset-medium leading-relaxed">
              Have questions, suggestions, or want to partner with us?<br className="hidden sm:block" />
              <span className="sm:hidden"> </span>Reach out at <span className="text-peach-orange font-medium">hello@FollowTheSun.live</span>
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutPage;
